module.exports = __webpack_public_path__ + "static/fonts/NanumSquareL.fa92696.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareL.woff
// module id = Tw1V
// module chunks = 1